import brandDefaults from "../../brand-config.json";
import { getRuntimeEnv } from "@/lib/runtimeEnv";

export type BrandPaths = {
  logo: string;
  favicon: string;
  ogImage: string;
};

export type BrandConfig = {
  brandName: string;
  brandNameShort: string;
  tagline: string;
  metaDescription: string;
  metaAuthor: string;
  twitterSite: string;
  hero: { emphasis: string; suffix: string };
  paths: BrandPaths;
};

const getBrandOverride = (key: Parameters<typeof getRuntimeEnv>[0]): string | undefined => {
  const value = getRuntimeEnv(key);
  if (typeof value !== "string") {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed === "" ? undefined : trimmed;
};

export function getBrandConfig(): BrandConfig & { logoAlt: string } {
  const name = getBrandOverride("VITE_BRAND_NAME") ?? brandDefaults.brandName;
  const brandNameShort = getBrandOverride("VITE_BRAND_NAME_SHORT") ?? brandDefaults.brandNameShort;
  const tagline = getBrandOverride("VITE_BRAND_TAGLINE") ?? brandDefaults.tagline;
  const metaDescription =
    getBrandOverride("VITE_BRAND_META_DESCRIPTION") ?? brandDefaults.metaDescription;
  const metaAuthor = getBrandOverride("VITE_BRAND_META_AUTHOR") ?? brandDefaults.metaAuthor;
  const twitterSite = getBrandOverride("VITE_BRAND_TWITTER_SITE") ?? brandDefaults.twitterSite;
  const heroEmphasis = getBrandOverride("VITE_BRAND_HERO_EMPHASIS") ?? brandDefaults.hero.emphasis;
  const heroSuffix = getBrandOverride("VITE_BRAND_HERO_SUFFIX") ?? brandDefaults.hero.suffix;
  const logo = getBrandOverride("VITE_BRAND_LOGO_URL") ?? brandDefaults.paths.logo;
  const favicon = getBrandOverride("VITE_BRAND_FAVICON_URL") ?? brandDefaults.paths.favicon;
  const ogImage = getBrandOverride("VITE_BRAND_OG_IMAGE_URL") ?? brandDefaults.paths.ogImage;

  return {
    ...brandDefaults,
    brandName: name,
    brandNameShort,
    tagline,
    metaDescription,
    metaAuthor,
    twitterSite,
    hero: {
      ...brandDefaults.hero,
      emphasis: heroEmphasis,
      suffix: heroSuffix,
    },
    paths: {
      ...brandDefaults.paths,
      logo,
      favicon,
      ogImage,
    },
    logoAlt: `${name} logo`,
  };
}
